import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-never-always',
  templateUrl: './disable-never-always.component.html',
  styleUrls: ['./disable-never-always.component.css'],
})
export class DisableNeverAlwaysComponent {
  @Input() question!: Question;
}
